import type { FC, ReactNode } from 'react';

import styles from '../SectionHeader.module.css';

const SectionHeaderLeft: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <div className={styles.headerLeft}>
      {children}
    </div>
  );
};

export default SectionHeaderLeft;